import { useAppSelector } from "@/redux/hooks";

import { useSplitClient } from "@splitsoftware/splitio-react";
import { useState, useEffect } from "react";

export const useAsyncCheckoutEnabled = () => {
  const userProfile = useAppSelector((state) => state.userProfile);
  const [treatment, setTreatment] =
    useState<"v1" | "v2" | "debug" | "off">("v2");
  const appId = useAppSelector(
    (state) => state.appConfig?.brandAppConfig?.appId
  );
  const appType = useAppSelector(
    (state) => state.appConfig?.brandAppConfig?.appType
  );
  const splitIO = useSplitClient();

  useEffect(() => {
    const splitTreatment = splitIO.client?.getTreatment(
      "brandclub_async_checkout",
      {
        email: userProfile?.email ?? "",
        appId: appId ?? "",
        appType: appType ?? "",
      }
    ) as "v1" | "v2" | "debug" | "off" | "control";

    if (splitTreatment && splitTreatment !== "control") {
      setTreatment(splitTreatment);
    }
  }, [splitIO, userProfile, appId, appType]);

  return {
    enabled: ["v1", "v2", "debug"].includes(treatment),
    debug: treatment === "debug",
    showExperimentalCheckout: treatment === "v2" || treatment === "debug",
  };
};
